module.exports = __webpack_public_path__ + "img/solution-banner.1510b405.png";